import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
// console.log(process.env.REACT_APP_API_URL);

const httpService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};

export default httpService;
